export const BROWSE = 'browse';
export const SUMMARY = 'summary';
export const BOOK = 'book';
export const CONFIRMATION = 'confirmation';
export const MENU = 'menu';
export const AUTH = 'auth';
export const CHOOSE_CC = 'chooseCC';
export const ADD_CC = 'addCC';
export const RESERVATION_PATH_PLACEMENT = 'reservationPathNaa';
